import { useGetFacilityServices } from '../../../App/customize/hooks/useGetFacilityServices';
import constants from '../../../../constants/constants';
import {
  COPY_COMM_HISTORY_INQUIRY_HEADER_TOOLTIP,
  SEND_MESSAGE_INQUIRY_HEADER_TOOLTIP,
} from '../../../../shared/components/table/contextualHelpTooltipContent';

const attachmentIcon = `${process.env.PUBLIC_URL}/img/icons/file-attachment-icon.png`;

const TOOLBAR_PLAIN_HEADER_KEYS = [
  'date',
  'parentFullName',
  'petName',
  'topicTitle',
  'doctorFullName',
  'inquiryStatus',
];

function withoutHeaderSortAndFilter(headers) {
  return headers.map((head) => {
    if (!TOOLBAR_PLAIN_HEADER_KEYS.includes(head.key)) {
      return head;
    }
    return {
      ...head,
      sortable: false,
      filterable: false,
    };
  });
}

function stripAllHeaderSortAndFilter(headers) {
  return headers.map((head) => ({
    ...head,
    sortable: false,
    filterable: false,
  }));
}

export function useGetInquiriesHeaders({ isClientPage = true } = {}) {
  const { data: services } = useGetFacilityServices();
  const allHeaders = [
    {
      key: 'date',
      name: 'Date',
      sortable: true,
      filterable: false,
      capitalize: true,
      className: 'date-column',
    },
    {
      key: 'time',
      name: 'Time',
      sortable: false,
      filterable: false,
      capitalize: true,
      className: 'time-column',
    },
    {
      key: 'copyHistory',
      name: 'Copy History',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'comm-copy-history-column',
      headerTooltip: COPY_COMM_HISTORY_INQUIRY_HEADER_TOOLTIP,
      headerTooltipClassName: 'lp-info-tooltip',
    },
    {
      key: 'topicTitle',
      name: 'Topic',
      sortable: false,
      filterable: true,
      filterValue: [],
      capitalize: false,
      className: 'inquiry-topic-column',
    },
    {
      key: 'message',
      name: 'Message',
      headerTooltip: SEND_MESSAGE_INQUIRY_HEADER_TOOLTIP,
      headerTooltipClassName: 'lp-info-tooltip',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'inquiry-message-column',
    },
    {
      key: 'messageStatus',
      name: 'Reply',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'inquiry-reply-column',
    },
    {
      key: 'lastMsg',
      name: 'Last Msg',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'inquiry-last-msg-column',
    },
    {
      key: 'internalComments',
      name: 'Staff Notes',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'inquiry-staff-notes-column',
    },
    {
      key: 'attachments',
      name: 'Attachments',
      imgSrc: attachmentIcon,
      imgAlt: 'File attachment icon',
      className: 'with-icon inquiry-attachment-column',
      sortable: false,
      filterable: false,
      capitalize: false,
    },
    {
      key: 'comments',
      name: 'Client Comments',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'inquiry-client-comments-column',
    },
    {
      key: 'parentFullName',
      name: 'Parent Name',
      sortable: true,
      filterable: false,
      capitalize: true,
      link: (row) =>
        `/client-list/profile/${row.parentId}?tab=${constants.QUERY_TAB_PARAMS.inquiries}`,
      className: 'inquiry-parent-column',
    },
    {
      key: 'petName',
      name: 'Pet Name',
      sortable: true,
      filterable: false,
      capitalize: true,
      link: (row) =>
        `/client-list/profile/${row.parentId}?tab=${constants.QUERY_TAB_PARAMS.inquiries}&${constants.QUERY_PARAMS.pet}=${row.petId}`,
      className: 'inquiry-pet-column',
    },
    {
      key: 'doctorFullName',
      name: 'Doctor',
      sortable: false,
      filterable: true,
      filterValue: [],
      capitalize: true,
      className: 'inquiry-doctor-column',
    },
    {
      key: 'inquiryStatus',
      name: 'Status',
      sortable: false,
      filterable: true,
      filterValue: [
        { open: 'Open' },
        { closed: 'Closed' },
        { closed_auto: 'Closed (Auto)' },
      ],
      capitalize: false,
      className: 'inquiry-status-column',
    },
  ];
  const headers = services?.isBoardingOnly
    ? allHeaders.filter((h) => h.key !== 'doctorFullName')
    : allHeaders;

  return isClientPage
    ? stripAllHeaderSortAndFilter(
        headers.filter(({ key }) => key !== 'parentFullName'),
      )
    : withoutHeaderSortAndFilter(headers);
}
